import {
  Company,
  CompanyType,
  saveCompany as saveCorp,
  savePerson,
  savePersonUser,
  Office
} from "@/api/company-api";
import buildEndUserData from "./buildEndUserData";
import buildPrivateCompanyData from "./buildPrivateCompanyData";
import buildCompanyData from "./buildCompanyData";

export default async function save(company: Company, office: Office) {
  if (company.companyTypeId === CompanyType.Corporation) {
    await saveCompany(company, office);
  } else if (company.companyTypeId === CompanyType.Individual) {
    await savePrivateCustomer(company, office);
  } else {
    await saveEndUser(company, office);
  }
}

async function saveCompany(company: Company, office: Office) {
  const d = buildCompanyData(company, office);
  await saveCorp(d);
}

async function savePrivateCustomer(company: Company, office: Office) {
  const d = buildPrivateCompanyData(company, office);
  await savePerson(d);
}

async function saveEndUser(company: Company, office: Office) {
  const d = buildEndUserData(company, office);
  await savePersonUser(d);
}
